module.exports = __webpack_public_path__ + "static/media/Snelweg.618d3c29.mp3";